/**
 * @voltxampere/engine — PWL source AC stamp (Sprint 22 B3)
 *
 * The PWL waveform is a transient stimulus with no AC small-signal
 * content. The AC stamp wires only the augmented MNA row's
 * structural coefficients; RHS stays zero. Pattern matches the
 * Sprint 22 B2 pulse-source AC stamp.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { ContractViolationError } from "@voltxampere/shared";
import { getTerminalNetId } from "../terminal-utils.js";
export const pwlSourceACStamp = (ctx, component) => {
    const pos = ctx.nodeIndex(getTerminalNetId(component, "pos"));
    const neg = ctx.nodeIndex(getTerminalNetId(component, "neg"));
    const k = ctx.vSourceIndex(component.id);
    if (k < 0) {
        throw new ContractViolationError(`pwlSourceACStamp: component "${component.id}" missing augmented row`);
    }
    ctx.addY(pos, k, 1, 0);
    ctx.addY(neg, k, -1, 0);
    ctx.addY(k, pos, 1, 0);
    ctx.addY(k, neg, -1, 0);
};
//# sourceMappingURL=pwl-source.js.map